module.exports = __webpack_public_path__ + "img/guge.ba7b7aef.png";